import React from 'react';
import styled from 'styled-components';

import Text from '../../basic/Text';
import Link from '../../util/link';
import Event from '../../util/GAEvent';
import BasicPlayButton from '@basic/buttons/BasicPlayButton';

import HTMLWrapper from '../../basic/HTMLWrapper';

import { MdChevronRight } from 'react-icons/md';

import theme from '../../../styles/theme';

const { colors } = theme;

// LINKS

const IconLinkWrapper = styled(Link)`
	display: flex;
	align-items: center;

	:hover {
		cursor: pointer;

		.icon-wrapper {
			img {
				filter: brightness(0) invert(1);
			}

			:after {
				background-color: ${colors.brandMain};
			}
		}
	}
`;

const IconImg = styled.div`
	display: block;
	position: relative;
	z-index: 0;

	img {
		padding: 10px;
		z-index: 1;
		position: relative;
	}

	&:after {
		content: '';
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-color: #f5f7f8;
		border-radius: 10px;
		transition: all 0.5s ease;
	}
`;

export const IconLink = ({ link, image, header, subheader }) => {
	return (
		<IconLinkWrapper to={link}>
			<IconImg className="icon-wrapper">
				<img src={image} />
			</IconImg>
			<div style={{ marginLeft: '12px' }}>
				<Text component="b5" semiBold css={subheader ? null : { margin: 0 }}>
					{header}
				</Text>
				{subheader && (
					<MenuWrapper
						html={subheader?.childMarkdownRemark?.html}
						color={colors.black}
					/>
				)}
			</div>
		</IconLinkWrapper>
	);
};

const ChevronLinkWrapper = styled(Link)`
	display: flex;
	align-items: center;

	background: linear-gradient(${colors.brandMain}, ${colors.brandMain});
	background-size: 0 2px;
	background-position: 0 100%;
	background-repeat: no-repeat;
	padding-bottom: 6px;
	transition:
		background-size 0.75s ease,
		color 0.75s ease;
	width: max-content;
	color: ${colors.black};

	svg {
		width: 20px;
		height: 20px;
		fill: ${colors.black};
	}

	:hover {
		background-size: 100% 2px;
		p {
			color: ${colors.brandMain};
		}
		svg {
			fill: ${colors.brandMain};
		}
	}
`;

export const ChevronLink = ({ link, header, subheader }) => {
	return (
		<ChevronLinkWrapper to={link}>
			<div>
				<Text component="b5" semiBold css={subheader ? null : { margin: 0 }}>
					{header}
				</Text>
				{subheader && (
					<MenuWrapper
						html={subheader?.childMarkdownRemark?.html}
						color={colors.black}
					/>
				)}
			</div>
			<MdChevronRight />
		</ChevronLinkWrapper>
	);
};

const FullFeatureLinkWrapper = styled(Link)`
	border-radius: 16px;
	background: #f5f7f8;
	padding: 16px;
	display: block;
	width: fit-content;

	.video-card__play-img {
		width: 100%;
		position: relative;

		.play-button__wrapper {
			position: absolute;
			left: 50%; /* Centers horizontally */
			top: 50%; /* Centers vertically */
			transform: translate(
				-50%,
				-50%
			); /* Offsets by half of its width & height */
		}
	}

	:hover {
		.play-button__wrapper {
			background-color: ${colors.primary.dark};
		}
	}
`;

const FullImg = styled.img`
	margin-bottom: 16px;
`;

export const FullFeatureLink = ({ image, link, subheader }) => {
	return (
		<FullFeatureLinkWrapper to={link}>
			{/* TODO FUTURE: Add a 'video' option in contentful if we need a version of this full feature that isn't a video */}
			<div className="video-card__play-img">
				<BasicPlayButton width={55} height={55} />
				<FullImg src={image} />
			</div>
			{subheader && (
				<MenuWrapper
					html={subheader?.childMarkdownRemark?.html}
					color={colors.black}
				/>
			)}
		</FullFeatureLinkWrapper>
	);
};

const SubtextLinkWrapper = styled(Link)`
	padding-bottom: 16px;
	display: block;

	:hover {
		cursor: pointer;
		.subtext-link__header {
			color: ${colors.brandMain};
		}
	}
`;

export const SubtextLink = ({ link, header, subheader }) => {
	return (
		<SubtextLinkWrapper to={link}>
			<Text
				component="b5"
				semiBold
				css={subheader ? null : { margin: 0 }}
				className="subtext-link__header"
			>
				{header}
			</Text>
			{subheader && (
				<MenuWrapper
					html={subheader?.childMarkdownRemark?.html}
					color={colors.black}
				/>
			)}
		</SubtextLinkWrapper>
	);
};

const LargeFeatureLinkWrapper = styled(Link)`
	margin-bottom: 16px;
	display: flex;
	align-items: center;

	:hover {
		cursor: pointer;
		.subtext-link__header {
			color: ${colors.brandMain};
		}
	}
`;

const LargeImg = styled.img`
	max-width: 150px;
	margin-right: 16px;
`;

export const LargeFeatureLink = ({ image, link, header, subheader }) => {
	return (
		<LargeFeatureLinkWrapper to={link}>
			<LargeImg src={image} />
			<div>
				<Text
					component="b5"
					semiBold
					css={subheader ? null : { margin: 0 }}
					className="subtext-link__header"
				>
					{header}
				</Text>
				{subheader && (
					<MenuWrapper
						html={subheader?.childMarkdownRemark?.html}
						color={colors.black}
					/>
				)}
			</div>
		</LargeFeatureLinkWrapper>
	);
};

const MenuWrapper = styled(HTMLWrapper)`
	color: #333;

	p:not([class^='Body']):not([class^='AllCaps']) {
		font-size: 16px;
		line-height: 20px;
		margin-bottom: 0;
	}
`;
